"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const StyledRecentItem_1 = require("./styled/StyledRecentItem");
const VerticalFocus_1 = __importDefault(require("./common/VerticalFocus"));
const AutoCompleteItem_1 = __importDefault(require("./AutoCompleteItem"));
const recentSearchList_1 = require("../../modules/recentSearchList");
const inputKeyDownHandler_1 = require("../../handler/autoComplete/desktop/Common/inputKeyDownHandler");
const indexImgUrl_1 = require("../../resource/indexImgUrl");
const RecentItem = (props) => {
    return ((0, jsx_runtime_1.jsx)(RecentItem.Button, { onKeyDown: inputKeyDownHandler_1.onRecentKeyDown, ...props, children: (0, jsx_runtime_1.jsx)(RecentItem.Info, { item: props.item, setRecentList: props.setRecentList }) }));
};
const Button = ({ children, idx, item, onRecentSearch, onAutoCompClick, onKeyDown, }) => {
    const autoContent = item.content;
    if (item.type === "query" && typeof item.content === "string") {
        return ((0, jsx_runtime_1.jsx)(StyledRecentItem_1.RecentItemDiv, { className: "Recent__Query__Wrap", height: 42, children: (0, jsx_runtime_1.jsxs)("button", { tabIndex: idx, className: "Recent__Query__Item", onClick: () => {
                    onRecentSearch({
                        type: "query",
                        content: item.content,
                        query: item.content,
                    });
                }, onKeyDown: onKeyDown, children: [(0, jsx_runtime_1.jsx)(VerticalFocus_1.default, { height: "42px" }), (0, jsx_runtime_1.jsx)("img", { className: "Recent__Query__Item__Img", src: indexImgUrl_1.desktop_search_item_img, alt: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4 \uBC84\uD2BC" }), (0, jsx_runtime_1.jsxs)("div", { className: "Recent__Search__Query__Content", children: [(0, jsx_runtime_1.jsx)("span", { className: "Recent__Search__Query", children: item.content }), children] })] }, item.content) }));
    }
    if (item.type === "location") {
        return ((0, jsx_runtime_1.jsx)(AutoCompleteItem_1.default, { idx: idx, main_name: autoContent.main_name, addr: autoContent.addr, rest_id: autoContent.rest_id, branch: autoContent.branch, isRecent: true, onAutoCompClick: onAutoCompClick, onKeyDown: onKeyDown, children: children }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
const Info = ({ item, setRecentList, }) => {
    const isQueryType = item.type === "query" && typeof item.content === "string";
    const isLocationType = item.type === "location";
    const autoContent = item.content;
    const parsedDate = new Date(item.time ? Date.parse(item.time) : "");
    const monthAndDay = parsedDate.getMonth() + 1 + "." + parsedDate.getDate();
    return ((0, jsx_runtime_1.jsx)(StyledRecentItem_1.RecentSearchInfoDiv, { className: "Recent__Search__Info", align: isQueryType ? "center" : "flex-start", padtop: isQueryType ? 0 : 1, children: (0, jsx_runtime_1.jsxs)("span", { className: "Recent__Info__Time", children: [item.time && monthAndDay, (0, jsx_runtime_1.jsx)("div", { className: "Recent__Info__Remove", children: (0, jsx_runtime_1.jsx)("span", { onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (isQueryType) {
                                (0, recentSearchList_1.removeRecent)({
                                    type: "query",
                                    content: item.content,
                                    query: item.content,
                                }, setRecentList);
                            }
                            if (isLocationType) {
                                const locationContent = item.content;
                                (0, recentSearchList_1.removeRecent)({
                                    type: "location",
                                    content: locationContent,
                                    query: locationContent.main_name
                                        ? locationContent.main_name +
                                            (locationContent.branch
                                                ? " " + locationContent.branch
                                                : "")
                                        : "",
                                    branch: locationContent.branch
                                        ? locationContent.branch
                                        : "",
                                }, setRecentList);
                            }
                        } }) })] }) }));
};
RecentItem.Button = Button;
RecentItem.Info = Info;
exports.default = RecentItem;
